import React, { useContext, useState } from "react";
import "./CardInput.scss";
import { isMobile } from '../../global/ScreenSizeHelper'
import InputBox from "../inputbox/InputBox";
import { CreditCardIcons } from "../../global/assets/Icons";
import fallBackImage from "../../global/assets/svg/ImageError.svg";
import { SignUpInfoDataContext } from "../../context-api/SignUpInfoDataProvider";
import { encryptPayload } from "../../utils/encryptPayload";


function getCardType(cardNumber) {
    const patterns = {
        "Visa": /^4/,
        "MasterCard": /^5[1-5]/,
        "American Express": /^3[47]/,
        "Diners Club": /^3(?:0[0-5]|[68])/,
        "Discover": /^6(?:011|5)/,
        "JCB": /^35/,
        "UnionPay": /^62/, // Optional: UnionPay starts with 62
        "Maestro": /^(50|56|57|58|6[37])/, // Maestro cards
    };

    for (const [cardType, pattern] of Object.entries(patterns)) {
        if (pattern.test(cardNumber)) {
            return cardType;
        }
    }
    return "fallback icon";
}


const CardInput = ({ showLabel = true }) => {
    const singnUpContext = useContext(SignUpInfoDataContext);


    const {
        setSignUpformValues,
        signUpformValues,
        isCardError, setCardError,
        cardNumber, setCardNumber,
        expiryMonth, setExpiryMonth,
        expiryYear, setExpiryYear,
        cvcValue, setCvcValue

    } = singnUpContext;


    const [cardErrorMessage, setCardErrorMessage] = useState(null)
    const [expiryMonthErrorMsg, setExpiryMonthErrorMsg] = useState(null)
    const [expiryYearErrorMsg, setExpiryYearErrorMsg] = useState(null)
    const [cvcErrorMsg, setCvcErrorMsg] = useState(null)
    const [cardType, setCardType] = useState(null)
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);


    const handleCardChange = (key) => (e) => {

        const value = e.target.value
        const NameVal = e.target.name

        if (NameVal === 'CardNumber') {
            setCardErrorMessage(null)
            if (cardType === 'american express' ? value.length <= 15 : value.length <= 16) {
                setCardNumber(value);
                setCardType(getCardType(value).toLocaleLowerCase())
                setSignUpformValues({ ...signUpformValues, [key]: encryptPayload(value) }); // This is for signup form we have store in this state
            }
            if (value.length === 0) {
                setCardError(false)
                setCardErrorMessage(null)
            }
        }


        if (NameVal === 'exp_month') {
            if (value.length <= 2) {
                setExpiryMonth(value);
                setSignUpformValues({ ...signUpformValues, [key]: encryptPayload(value) }); // This is for signup form we have store in this state
            }
            if (value.length === 0) {
                setCardError(false)
                setExpiryMonthErrorMsg(null)
            }
        }



        if (NameVal === 'exp_year') {
            if (value.length <= 4) {
                setExpiryYear(value);
                setSignUpformValues({ ...signUpformValues, [key]: encryptPayload(value) }); // This is for signup form we have store in this state
            }
            if (value.length === 0) {
                setCardError(false)
                setExpiryYearErrorMsg(null)
            }
        }

        if (NameVal === 'cvc') {
            if (value.length <= 3) {
                setCvcValue(value);
                setSignUpformValues({ ...signUpformValues, [key]: encryptPayload(value) }); // This is for signup form we have store in this state
            }
            if (value.length === 0) {
                setCardError(false)
                setCvcErrorMsg(null)
            }
        }
    }


    const handleBlur = (e) => {
        const value = e.target.value
        const valName = e.target.name
        if (valName === 'CardNumber') {
            if (value.length > 0) {
                setCardError(cardType === 'american express' ? value.length < 15 : value.length < 16); // Set error if length is less than 16
                setCardErrorMessage('Your card number is incomplete.')
            }

            if (cardType === 'american express' ? value.length === 15 : value.length === 16) {
                setCardErrorMessage(null)
                setCardError(false);
            }
        }

        if (valName === 'exp_month') {
            if (value.length > 0) {
                setCardError(value.length < 2);
                setExpiryMonthErrorMsg('Incomplete.')
            }

            if (value.length === 2) {
                setExpiryMonthErrorMsg(null)
                setCardError(false);
            }
        }


        if (valName === 'exp_year') {
            if (value.length > 0) {
                setCardError(value.length < 4);
                setExpiryYearErrorMsg('Incomplete.')
            }

            if (value.length === 4) {
                setExpiryYearErrorMsg(null)
                setCardError(false);
            }
        }

        if (valName === 'cvc') {
            if (value.length > 0) {
                setCardError(value.length < 3);
                setCvcErrorMsg('Incomplete.')
            }

            if (value.length === 3) {
                setCvcErrorMsg(null)
                setCardError(false);
            }
        }

    };


    const onImageLoad = () => {
        setImageLoaded(true);
    };

    const onImageError = () => {
        setImageError(true);
        setImageLoaded(true);
    };


    return (
        <div className="credit-card-style-container">

            {showLabel && <div style={{
                fontFamily: 'Inter Medium', fontSize: '16px',
                marginBottom: '10px', color: 'rgb(24, 20, 54)'
            }}>Enter Card Detail

            </div>}

            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <InputBox
                    type="number"
                    label="Card number"
                    size="small"
                    sx={{
                        width: isMobile ? "320px" : "350px",
                        height: "auto",
                        margin: "6px 5px 5px 0px",
                    }}
                    name="CardNumber"
                    value={(cardNumber || signUpformValues?.card_number)}
                    onBlur={handleBlur}
                    error={isCardError}
                    inputErrorMsg={cardErrorMessage}
                    onChange={handleCardChange("card_number")}
                    inputProps={{
                        startAdornment:
                            <img
                                alt={cardType}
                                width={imageLoaded ? "25px" : '25px'}
                                style={{ marginRight: '10px' }}
                                src={imageError ? fallBackImage : CreditCardIcons[cardType] || CreditCardIcons['fallback icon']}
                                onLoad={() => onImageLoad()}
                                onError={() => onImageError()}
                                onClick={() => {
                                    // console.log("image clicked pdp desktop");
                                }}
                            />,

                    }}
                />

                <div style={{ display: 'flex', flexDirection: 'row', }}>

                    <InputBox
                        type="number"
                        label="MM"
                        size="small"
                        sx={{
                            width: "80px",
                            height: "auto",
                            margin: "6px 5px 5px 0px",
                        }}
                        name="exp_month"
                        value={(expiryMonth || signUpformValues?.exp_month)}
                        onBlur={handleBlur}
                        error={isCardError}
                        inputErrorMsg={expiryMonthErrorMsg}
                        onChange={handleCardChange("exp_month")}
                        inputProps={{}}
                    />
                    <InputBox
                        type="number"
                        label="YYYY"
                        size="small"
                        sx={{
                            width: "100px",
                            height: "auto",
                            margin: "6px 5px 5px 0px",
                        }}
                        name="exp_year"
                        value={(expiryYear || signUpformValues?.exp_year)}
                        onBlur={handleBlur}
                        error={isCardError}
                        inputErrorMsg={expiryYearErrorMsg}
                        onChange={handleCardChange("exp_year")}
                        inputProps={{}}
                    />


                    <InputBox
                        type="number"
                        label="CVC"
                        size="small"
                        sx={{
                            width: "80px",
                            height: "auto",
                            margin: "6px 5px 5px 0px",
                        }}
                        name="cvc"
                        value={(cvcValue || signUpformValues?.cvc)}
                        onBlur={handleBlur}
                        error={isCardError}
                        inputErrorMsg={cvcErrorMsg}
                        onChange={handleCardChange('cvc')}
                        inputProps={{}}
                    />


                </div>
            </div>



            {/* {!hideInfo && <div style={{ margin: "10px 0px" }}>
                <b style={{ color: "blue" }}>Note:</b> We do not charge amount for sign
                up.
            </div>} */}
            {/* <div className="card-errors" role="alert">
                {error}
            </div> */}
        </div>
    );
};

export default CardInput;
